export default __webpack_public_path__ + "static/media/logo_test.30011305.png";